export const getRequiredMessage = (field: string) => `Please enter a ${field}.`
